import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';
import * as moment from 'moment';

import { ComponentDefinition, Identifier, IValueViewModel, GroupNameDto } from '../../../models';
import { Roles, momentFormat } from '../../../common/';
import { ICalculatedStateParams } from '../components.index';
import { IAuthorizationService, IStoreService } from '../../../services';
import { Store, StoreElement } from '../../../stateManagement';

class CalculatedContainerStateController implements angular.IComponentController, angular.IOnDestroy {
    currentBeginDate: string;
    currentEndDate: string;
    currentInterval: any;
    dates: { beginDate, endDate };
    hasManualInputRole: boolean;
    identifier: Identifier;
    identifierGroup: GroupNameDto;
    identifierGuid: string;
    identifierVm: IValueViewModel;
    initialRange: { beginDate: any, endDate: any; };
    isLoadingData: boolean;
    isLoadingIdentifier: boolean;
    load: () => void;
    loadingMessage: string;
    target: boolean;

    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        'storeService',
        'authorizationService',
    ];
    private _unsubscribe: () => void;

    constructor(
        private _$scope: angular.IScope,
        private _$state: StateService,
        private _$stateParams: ICalculatedStateParams,
        private _storeService: IStoreService,
        authorizationService: IAuthorizationService,
    ) {
        if (this.dates && this.dates.beginDate && this.dates.endDate) {
            this.initialRange = {
                beginDate: moment(this.dates.beginDate).format(momentFormat),
                endDate: moment(this.dates.endDate).format(momentFormat)
            };
        }
        this.hasManualInputRole = authorizationService.isInRoles(Roles.manualInputRoles);
    }

    $onInit() {
        this.identifierGuid = this._$stateParams.identifierGuid;
        this.loadingMessage = 'Loading identifier';

        if (this._$stateParams.beginDate && this._$stateParams.endDate && !this.initialRange) {
            this.initialRange = {
                beginDate: moment(this._$stateParams.beginDate).format(momentFormat),
                endDate: moment(this._$stateParams.endDate).format(momentFormat)
            };
        }


        this.isLoadingIdentifier = true;
        this._unsubscribe = this._storeService.register(
            s => this.reloadStore(s),
            [
                StoreElement.ValueViewModels,
                StoreElement.Identifiers
            ]
        );

        this._$scope.$watchGroup([() => this.currentBeginDate, () => this.currentEndDate], () => {
            this.currentInterval = { startDate: this.currentBeginDate, endDate: this.currentEndDate };
        });
    }

    reloadStore(store: Store) {
        const { identifiers, valueViewModels } = store;
        const identifierVm = valueViewModels.dictionary[this.identifierGuid];

        let identifierGroup;
        if (identifierVm) {
            this._$state.current.data.breadcrumbs.level4 = identifierVm.name;
            identifierGroup = identifierVm.groupList[0];
        }

        this.isLoadingIdentifier = false;
        this.identifierVm = identifierVm;
        this.identifier = identifiers.dictionary[this.identifierGuid];
        this.identifierGroup = identifierGroup;
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
}

export const wtCalculatedContainerState: ComponentDefinition = {
    componentId: 'wtCalculatedContainerState',
    controller: CalculatedContainerStateController,
    template: require('./calculatedContainerState.component.html'),
    controllerAs: 'vm',
    bindings: {
        dates: '<'
    }
};